// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app--dragover .attachment-area{min-height:36px;border:2px dashed #787f87;border-radius:2px}.app--dragover .attachment-area:hover{border-color:#303336}.app--dragover .attachment-area__drop-message{text-align:center;display:block !important}.attachment-area{margin-bottom:12px;padding:8px}.attachment-area .attachment-area__upload,.attachment-area .attachment-area__drop-message{display:none}", ""]);
// Exports
module.exports = exports;
